import api from './axiosApi'
import type {
  PaginatedStoreGroupsResponse,
  StoreGroupDetailRead,
  StoreGroupRead,
  StoreGroupMemberListResponse,
  StoreGroupUpdate,
  GroupingMethod,
} from '@/types'

interface ListStoreGroupsParams {
  search?: string
  store_model_id?: string
  grouping_method?: GroupingMethod
  skip?: number
  limit?: number
}

export async function listStoreGroups(
  params: ListStoreGroupsParams = {}
): Promise<PaginatedStoreGroupsResponse> {
  const { search, store_model_id, grouping_method, skip = 0, limit = 20 } = params

  const response = await api.get<PaginatedStoreGroupsResponse>(
    '/admin/store-groups',
    {
      params: {
        search: search || undefined,
        store_model_id: store_model_id || undefined,
        grouping_method: grouping_method || undefined,
        skip,
        limit,
      },
    }
  )

  return response.data
}

export async function getStoreGroupDetail(
  groupId: string
): Promise<StoreGroupDetailRead> {
  const response = await api.get<StoreGroupDetailRead>(
    `/admin/store-groups/${groupId}`
  )
  return response.data
}

interface UpdateStoreGroupParams {
  groupId: string
  payload: StoreGroupUpdate
  rowVersion?: number
}

export async function updateStoreGroup({
  groupId,
  payload,
  rowVersion,
}: UpdateStoreGroupParams): Promise<StoreGroupRead> {
  const headers: Record<string, string> = {}
  if (rowVersion != null) {
    headers['If-Match'] = String(rowVersion)
  }

  const response = await api.patch<StoreGroupRead>(
    `/admin/store-groups/${groupId}`,
    payload,
    { headers }
  )
  return response.data
}

interface ListStoreGroupStoresParams {
  groupId: string
  search?: string
  region?: string
  skip?: number
  limit?: number
}

export async function listStoreGroupStores(
  params: ListStoreGroupStoresParams
): Promise<StoreGroupMemberListResponse> {
  const { groupId, search, region, skip = 0, limit = 20 } = params

  const response = await api.get<StoreGroupMemberListResponse>(
    `/admin/store-groups/${groupId}/stores`,
    {
      params: {
        search: search || undefined,
        region: region || undefined,
        skip,
        limit,
      },
    }
  )

  return response.data
}
